exports.AUTH_ROUTES = [
  "/home",
  "/bristol",
  "/user/profile",
  "/user/settings",
  "/contact",
];

exports.NOT_AUTH_ROUTES = ["/", "/register", "/forgot-password"];
